<template>
  <div class="container-fluid px-0">
    <div class="row py-4" style="max-width: 1080px; margin: 0 auto">
      <div class="col-12 col-lg-5 mb-4">
        <div class="auth-hero">
          <small class="auth-hero__eyebrow">Cuenta</small>
          <h2 class="auth-hero__title">Ingresa para ver tus pedidos</h2>
          <p class="auth-hero__text">
            Revisa pedidos anteriores, seguimiento y datos guardados para
            comprar más rápido.
          </p>
          <router-link class="auth-hero__link" :to="getLink('registro')">
            ¿No tienes cuenta? Crear una
          </router-link>
        </div>
      </div>

      <div class="col-12 col-lg-7">
        <div class="auth-card">
          <div class="auth-card__header">
            <h3 class="mb-1">Ingresar</h3>
            <small class="text-muted">Usa tu correo y contraseña</small>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">Correo</label>
            <input
              type="email"
              autocapitalize="off"
              v-model.trim="email"
              class="form-control auth-input"
              :class="{
                'is-invalid': email && emailIsValid,
                'is-valid': email && !emailIsValid,
              }"
              placeholder="tu@correo.cl"
            />
          </div>

          <div class="form-group">
            <label class="font-weight-bold">Contraseña</label>
            <input
              type="password"
              v-model="password"
              class="form-control auth-input"
              placeholder="*******"
              @keyup.enter="login()"
            />
          </div>

          <div class="d-flex flex-wrap align-items-center justify-content-between pt-2">
            <button
              class="btn btn-primary auth-submit"
              @click="login()"
              :disabled="loading || !email || !password || emailIsValid"
            >
              {{ loading ? "Ingresando..." : "Ingresar" }}
            </button>

            <button class="btn btn-link px-0" @click="sendRecover()">
              Recuperar contraseña
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: this.$cookies.get("email") || "",
      password: "",
      loading: false,
    };
  },
  computed: {
    emailIsValid() {
      const email = this.email;
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !re.test(String(email).toLowerCase());
    },
  },
  methods: {
    login() {
      if (!this.email || !this.password || this.emailIsValid) return;

      this.loading = true;
      this.$http
        .post(`account/auth`, {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          this.password = "";
          this.$cookies.set("token", res.data.data.token);
          this.$cookies.set("email", res.data.data.email);
          this.$cookies.set("clientName", res.data.data.name);
          this.$cookies.set("phone", res.data.data.phone);
          this.loadRemoteCart({ force: true }).finally(() => {
            this.$router.push(this.getLink("cuenta"));
          });
        })
        .catch(({ data }) => {
          const details = data && data.details ? data.details : "";
          this.$bvToast.toast(details || "Usuario o contraseña incorrecto", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendRecover() {
      if (!this.email || this.emailIsValid) {
        this.$bvToast.toast("Ingresa un correo válido para recuperar acceso", {
          title: "Recuperar cuenta",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.loading = true;
      this.$http
        .post("account/recover", { email: this.email })
        .then(() => {
          this.$bvToast.toast("Se ha enviado un correo con las instrucciones", {
            title: "Recuperar cuenta",
            variant: "success",
            solid: true,
          });
        })
        .catch(() => {
          this.$bvToast.toast("No se ha podido enviar el correo", {
            title: "Recuperar cuenta",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.auth-hero,
.auth-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
}

.auth-hero {
  height: 100%;
  padding: 1.5rem;
}

.auth-hero__eyebrow {
  display: block;
  margin-bottom: 0.45rem;
  color: #0f766e;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.auth-hero__title {
  font-weight: 800;
  color: #1e293b;
}

.auth-hero__text {
  color: #64748b;
  max-width: 34rem;
}

.auth-hero__link {
  font-weight: 700;
  color: #2563eb !important;
}

.auth-card {
  padding: 1.5rem;
}

.auth-card__header {
  margin-bottom: 1.25rem;
}

.auth-input {
  min-height: 48px;
  border-radius: 14px;
}

.auth-submit {
  min-width: 160px;
  min-height: 46px;
  border-radius: 14px;
  font-weight: 700;
}

.bg-dark .auth-hero,
.bg-dark .auth-card {
  background: rgba(15, 23, 42, 0.82);
  border-color: rgba(71, 85, 105, 0.9);
}

.bg-dark .auth-hero__title,
.bg-dark .auth-card h3,
.bg-dark label {
  color: #f8fafc;
}

.bg-dark .auth-hero__text,
.bg-dark .text-muted {
  color: #cbd5e1 !important;
}
</style>
